module.exports = __webpack_public_path__ + "img/symbol_3.2e40b7e2.png";